import {AgeSlider} from './age-slider';

export default AgeSlider;
